<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->
<template>
  <div class="min-h-screen">
    <!-- 导航栏 -->
    <nav class="fixed top-0 w-full bg-white opacity-90 backdrop-blur-sm z-50 shadow-sm">
      <div class="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between">
        <div class="flex items-center space-x-2">
          <img :src="logoUrl" alt="绩溪县适之青少年俱乐部" class="h-12 w-12 object-contain"/>
          <span class="text-2xl font-bold text-blue-600">绩溪县适之青少年俱乐部</span>
        </div>
        <div class="flex space-x-8 items-center">
          <a v-for="(item, index) in navItems" :key="index" :href="item.href"
             class="text-gray-600 hover:text-blue-600 transition-colors duration-300 cursor-pointer">
            {{ item.title }}
          </a>
          <button @click="showLoginDialog = true"
                  class="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-colors duration-300">
            登录/注册
          </button>
        </div>
      </div>
    </nav>
    <!-- Hero区域 -->
    <div class="relative h-screen">
      <div class="absolute inset-0">
        <img :src="heroImage" alt="hero" class="w-full h-full object-cover"/>
        <div class="absolute inset-0 bg-gradient-to-r from-blue-900 to-blue-0 to-transparent"></div>
      </div>
      <div class="relative max-w-7xl mx-auto px-4 h-full flex items-center">
        <div class="text-white max-w-2xl">
          <h1 class="text-6xl font-bold mb-6">探索・成长・蜕变</h1>
          <p class="text-xl mb-8">
            在绩溪县适之青少年俱乐部，我们致力于培养青少年的身体素质、运动素养和竞技能力，让每一个孩子都能找到属于自己的成长道路。</p>
          <button @click="gotoHome"
                  class="!rounded-button bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 text-lg transition-colors duration-300">
            立即报名
          </button>
        </div>
      </div>
    </div>
    <!-- 俱乐部简介 -->
    <div id="our-advantages" class="py-20 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4">
        <h2 class="text-4xl font-bold text-center mb-16">我们的优势</h2>
        <div class="grid grid-cols-3 gap-8">
          <div v-for="(feature, index) in features" :key="index"
               class="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
            <img :src="feature.image" alt="feature" class="w-full h-48 object-cover rounded-lg mb-6"/>
            <h3 class="text-xl font-bold mb-4">{{ feature.title }}</h3>
            <p class="text-gray-600 mb-6">{{ feature.description }}</p>
            <!--<button class="!rounded-button text-blue-600 hover:text-blue-700 font-semibold transition-colors duration-300">
            了解更多 →
            </button>-->
          </div>
        </div>
      </div>
    </div>
    <!-- 报名区域 -->
    <!--<div class="py-20 bg-white">
    <div class="max-w-7xl mx-auto px-4">
    <h2 class="text-4xl font-bold text-center mb-16">加入我们，开启成长之旅</h2>
    <div class="max-w-2xl mx-auto">
    <el-form :model="formData" class="space-y-6">
    <el-form-item>
    <el-input v-model="formData.name" placeholder="姓名" class="!rounded-button" />
    </el-form-item>
    <el-form-item>
    <el-input v-model="formData.age" placeholder="年龄" class="!rounded-button" />
    </el-form-item>
    <el-form-item>
    <el-input v-model="formData.phone" placeholder="联系电话" class="!rounded-button" />
    </el-form-item>
    <el-form-item>
    <el-select v-model="formData.interest" placeholder="感兴趣的课程" class="w-full !rounded-button">
    <el-option v-for="course in courses" :key="course" :label="course" :value="course" />
    </el-select>
    </el-form-item>
    <el-button type="primary" class="w-full !rounded-button" @click="submitForm">
    提交报名
    </el-button>
    </el-form>
    </div>
    </div>
    </div>-->
    <!-- 联系我们 -->
    <div class="py-20 bg-gray-50">
      <div class="max-w-7xl mx-auto px-4">
        <h2 id="our-contact" class="text-4xl font-bold text-center mb-16">联系我们</h2>
        <div class="grid grid-cols-2 gap-12">
          <div class="space-y-8">
            <div v-for="(contact, index) in contactInfo" :key="index" class="flex items-start space-x-4">
              <!--<el-icon class="text-blue-600 text-xl"><component :is="contact.icon" /></el-icon>-->
              <el-icon class="text-blue-600 text-xl">
                <font-awesome-icon :icon="contact.icon"/>
              </el-icon>
              <div>
                <h3 class="font-bold mb-2">{{ contact.title }}</h3>
                <p class="text-gray-600">{{ contact.content }}</p>
              </div>
            </div>
          </div>
          <div class="bg-white rounded-xl p-8 shadow-lg">
            <img :src="mapImage" alt="map" class="w-full h-80 object-cover rounded-lg"/>
          </div>
        </div>
      </div>
    </div>
    <!-- 页脚 -->
    <footer class="bg-gray-900 text-white py-12">
      <div class="max-w-7xl mx-auto px-4">
        <div class="grid grid-cols-3 gap-8 mb-8">
          <!--          <div v-for="(section, index) in footerSections" :key="index">
                      <h3 class="font-bold mb-4">{{ section.title }}</h3>
                      <ul class="space-y-2">
                        <li v-for="(item, itemIndex) in section.items" :key="itemIndex">
                          <a href="#" class="text-gray-400 hover:text-white transition-colors duration-300">{{ item }}</a>
                        </li>
                      </ul>
                    </div>-->
          <div>
            <div class="space-y-2 mb-6">
              <a href="https://beian.miit.gov.cn/#/Integrated/index"
                 class="text-gray-400 hover:text-white transition-colors duration-300">IPC备案号：皖ICP备2025078433号</a>
            </div>
            <div class="flex items-center space-x-2">
              <img src="/images/logo01.6189a29f.png" class="h-5 w-5"><a
                href="https://beian.mps.gov.cn/#/query/webSearch"
                class="text-gray-400 hover:text-white transition-colors duration-300">公安备案号：皖公网安备34182402000225号</a>
            </div>
          </div>
        </div>
        <div class="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>© 2025 绩溪县适之青少年俱乐部. 保留所有权利</p>
        </div>
      </div>
    </footer>
    <!-- 在 template 的最后添加 -->
    <el-dialog
        :visible.sync="showLoginDialog"
        title="登录/注册"
        width="30%"
        center
    >
      <el-form :model="loginForm" label-width="80px">
        <el-form-item label="手机号">
          <div class="flex gap-2">
            <el-input v-model="loginForm.phone" placeholder="请输入手机号" class="login-input"/>
            <span
                v-if="countdown > 0"
                class="text-blue-600 cursor-not-allowed"
            >
          {{ countdown }}秒后重试
        </span>
            <span
                v-else
                class="text-blue-600 cursor-pointer hover:text-blue-700"
                @click="showVerify"
            >
          获取验证码
        </span>
          </div>
        </el-form-item>
        <el-form-item label="验证码">
          <el-input v-model="loginForm.captchaCode" placeholder="请输入验证码" class="login-input"/>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showLoginDialog = false">取消</el-button>
        <el-button type="primary" @click="handleLogin">登录</el-button>
      </template>

      <!-- 滑动验证组件 -->
      <slider-verify
          :visible="showSliderVerify"
          @close="showSliderVerify = false"
          @success="onVerifySuccess"
      />
    </el-dialog>
  </div>
</template>

<script>
import SliderVerify from '@/components/SliderVerify.vue';
import {PostRequest, GetRequest} from "@/request";
import { setCookie } from "@/utils/cookie";
export default {
  components: {
    SliderVerify
  },
  data() {
    return {
      logoUrl: 'https://ai-public.mastergo.com/ai/img_res/1c028ef08f60fe9a9e3c627b321b2fc4.jpg',
      heroImage: 'https://ai-public.mastergo.com/ai/img_res/3f20d22e35f16b5da96c978bef299623.jpg',
      navItems: [
        {title: '首页', href: '#'},
        {title: '关于我们', href: '#our-advantages'},
        {title: '联系方式', href: '#our-contact'}
      ],
      features: [
        {
          title: '专业教练团队',
          description: '由在校老师和专家组成的教练团队，为学生提供全方位的指导与关怀。',
          image: 'https://ai-public.mastergo.com/ai/img_res/c55872eb0dfbf544e687d9155829fb58.jpg'
        },
        {
          title: '科学训练计划',
          description: '根据每个孩子的特点和需求，制定专属的训练计划，让学生在适合的节奏中不断进步。',
          image: 'https://ai-public.mastergo.com/ai/img_res/638e75bbe16460b7e9c886a7f04f8a2c.jpg'
        },
        {
          title: '丰富的比赛活动',
          description: '组织各类项目的竞技比赛活动，培养学生的综合能力和团队精神。',
          image: 'https://ai-public.mastergo.com/ai/img_res/80a27fb844456bfdbf935b3cde5799f8.jpg'
        }
      ],
      formData: {
        name: '',
        age: '',
        phone: '',
        interest: ''
      },
      courses: [
        '领导力培训营',
        '创新思维工作坊',
        '公共演讲训练',
        '团队协作挑战',
        '艺术创作坊'
      ],
      contactInfo: [
        {
          icon: 'location-dot',
          title: '地址',
          content: '绩溪县华阳镇洪川路2号'
        },
        {
          icon: 'phone-plus',
          title: '电话',
          content: '咨询电话：18098569377（微信同号）'
        },
        {
          icon: 'envelope',
          title: '邮箱',
          content: '1478508149@qq.com'
        }
      ],
      mapImage: 'https://ai-public.mastergo.com/ai/img_res/67c4e4b4611c38422eec996b85031bf9.jpg',
      footerSections: [
        {
          title: '关于我们',
          items: ['俱乐部简介', '师资力量', '发展历程', '新闻动态']
        },
        {
          title: '课程项目',
          items: ['领导力培训', '创新思维', '团队建设', '艺术创作']
        },
        {
          title: '服务支持',
          items: ['报名流程', '常见问题', '家长指南', '学员反馈']
        },
        {
          title: '联系方式',
          items: ['联系我们', '招聘信息', '商务合作', '意见反馈']
        }
      ],
      showLoginDialog: false,
      loginForm: {
        phone: '',
        captchaCode: ''
      },
      countdown: 0,
      timer: null,
      showSliderVerify: false
    };
  },
  methods: {
    showVerify() {
      // 验证手机号格式
      if (!this.loginForm.phone || !/^1[3-9]\d{9}$/.test(this.loginForm.phone)) {
        this.$message.error('请输入正确的手机号码');
        return;
      }
      // 显示滑动验证
      this.showSliderVerify = true;
    },
    onVerifySuccess() {
      // 滑动验证成功后，关闭验证弹窗并发送验证码
      this.showSliderVerify = false;
      this.sendCode();
    },
    sendCode() {
      this.countdown = 60;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);
      GetRequest("/sendCaptchaCode", {
        phone: this.loginForm.phone
      }).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '验证码发送成功'
          });
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          });
        }
      });
    },
    handleLogin() {
      if (!this.loginForm.phone || !/^1[3-9]\d{9}$/.test(this.loginForm.phone)) {
        this.$message.error('请输入正确的手机号码');
        return;
      }
      if (!this.loginForm.captchaCode) {
        this.$message.error('请输入验证码');
        return;
      }
      //执行登录逻辑
      PostRequest("/loginByPhone", {
        phone: this.loginForm.phone,
        captchaCode: this.loginForm.captchaCode
      }).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '登录成功'
          });
          setCookie("Authorization", res.data.token);
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          });
        }
      });
      this.showLoginDialog = false;
    },
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    gotoHome() {
      this.$router.push('/home');
    }
  }
}
</script>

<style scoped>
.el-input :deep(.el-input__wrapper) {
  border-radius: 8px;
  box-shadow: none;
  border: 1px solid #e5e7eb;
}

.el-select :deep(.el-input__wrapper) {
  border-radius: 8px;
  box-shadow: none;
  border: 1px solid #e5e7eb;
}

.el-button {
  height: 48px;
  font-size: 16px;
}

.el-dialog {
  border-radius: 12px;
  z-index: 9999 !important;
}

.slider-container {
  position: relative;
  width: 300px;
  height: 40px;
  background-color: #e5e7eb;
  border-radius: 20px;
  margin-top: 10px;
}

.slider-track {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: #3b82f6;
  border-radius: 20px;
}

.slider-thumb {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  background-color: #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.verify-success {
  color: #10b981;
  font-weight: bold;
  margin-top: 10px;
}

.login-input {
  width: 80%;
}
</style>

